var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner-control-block h-center"},[_c('b-spinner',{style:(_vm.admin ? 'background-color: #00af00' : 'background-color: #93C660'),attrs:{"id":"spinner-control","variant":"light","type":"grow","label":"Loading..."}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }